module.exports = __webpack_public_path__ + "img/Health&Fitness-low.819909d2.jpg";